import React from "react";

import css from "./Row.module.css";

import cn from "classnames";

type Props = {
    justify?: "space-between" | "flex-start" | "flex-end";
    align?: "flex-start" | "flex-end" | "center";
    gap?: "8px" | "40px";
    className?: string;
};

export const Row: React.FC<React.PropsWithChildren<Props>> = ({
    children,
    justify = "space-between",
    gap = "8px",
    align,
    className,
}) => {
    return (
        <div
            className={cn(css.main, className)}
            style={{ justifyContent: justify, gap, alignItems: align }}
        >
            {children}
        </div>
    );
};
